// extracted by mini-css-extract-plugin
module.exports = {"personalBests":"skeleton_personalBests__zuCV8","popularGames":"skeleton_popularGames__71AEC"};